import {DeepLinkActionBase} from '../deep-link-action-base';
import Device from "../../../../../sdk/src/utils/device/device";

export abstract class PlayGameDeepLinkActionBase extends DeepLinkActionBase {

  protected abstract getIsRealMode(): boolean;

  // Play Game never execute the next action
  async execute(): Promise<void> {

    const gameType = this._getGameType();

    if(!gameType) {
      return;
    }

    const gameInfo = await this.services.games.getGameInfo(gameType);
    if(!gameInfo) {
      this.services.logger.error(`Game type ${this.descriptor.actionParams.id} was not found!`);

      if (this._shouldOpenGameInWebApp(gameType)) {
            // open webApp deeplink with this game
            this.services.sdk.openHybridLink(`/#deeplink=${encodeURIComponent(this.deepLinkToString())}`);
            return;
      }

      this.services.analytics.sendAnalytics("CorrelatedGamePopUp", "Game_Unavailable", gameType.toString());
      await this._suggestCorrelatedGame(gameType);
      return;
    }

    if(Device.hybrid.isHybrid && this.services.sdk.isGameRunning()) {
      this.services.analytics.sendAnalytics("Investigation", "DeepLink_With_Game_Already_Opened_App");
    } else {
      await gameInfo.open({
        isRealMode: this.getIsRealMode(),
        marketingParams: this.descriptor.marketingParams
      });
    }
  }

  private _shouldOpenGameInWebApp(gameType: number) {
    return this.services.device.hybrid.isEmbedded &&
        !this.services.sdk.isHybridEmbeddedGame(gameType) &&
        !this.services.regulation.shouldPreventOpenGameForMobileWebApp();
  }

  private async _suggestCorrelatedGame(gameType: number) {
    let suggestedGameType: number;
    const correlatedGames = await this.services.games.getCorrelatedGames(gameType, 10) || [];

    if(correlatedGames?.length > 0) {
      const gamesInfoArray = await this.services.games.getGamesInfoArray(correlatedGames) || [];

      if (gamesInfoArray?.length > 0) {
        suggestedGameType = gamesInfoArray[0].gameType;
      }
    }

    if (!suggestedGameType) {
      this.services.logger.error(`No correlated in layout games are found for game type ${this.descriptor.actionParams.id}, getCorrelatedGames: ${correlatedGames.join(';')}!`);

      const suggestedAIGameTypes = this.services.aiEngine.aiRecommendedGames?.gameTypes || [];

      if (suggestedAIGameTypes.length === 0) {
        this.services.logger.debug(`No correlated in ai suggested games are found for game type ${this.descriptor.actionParams.id}`);
        return;
      }
      const randomGameIndex = Math.floor(Math.random() * Math.min(10, suggestedAIGameTypes.length));
      suggestedGameType = suggestedAIGameTypes[randomGameIndex];

      //Check if the chosen GameType is allowed in the game layout
      if (!(await this.services.games.getGameInfo(suggestedGameType))) {
        return;
      }
    }

    await this.services.gamePopup.showSuggestedGame(suggestedGameType, this.services.translation.translate("GAME_POPUP_GAME_UNAVAILABLE"), this.services.translation.translate("GAME_POPUP_MAY_LIKE"));
  }

  private _getGameType(): number | null | undefined {
    if(!this.descriptor.actionParams && !this.descriptor.actionParams.id) {
      this.services.logger.error('No parameters were specified for play game deep link action');
      return null;
    }
    let gameTypes = this.descriptor.actionParams.id.toString().split(',').map(gameType => gameType.trim());

    if(gameTypes.length === 1) {
      return parseInt(gameTypes[0]);
    }

    if(gameTypes.length > 1) {
      if(this.services.device.os.isMobileOS) {
        return parseInt(gameTypes[1]);
      } else {
        return parseInt(gameTypes[0]);
      }
    }
  }


}
